module.exports = __webpack_public_path__ + "f0169118ea076e55edec6eb64364918a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/footer/image-2.jpg
// module id = ./assets/images/footer/image-2.jpg
// module chunks = 0